import moment from 'moment'
import { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { PayrollDetail } from '../../../components/payroll/payroll-detail/PayrollDetail'
import { INITIAL_DATA_QUERY_DETAIL, TABLE_PAYROLL_DETAIL } from '../../../configs/payroll/configTablePayrollList'
import { API_PAYROLL_LIST } from '../../../services/apiPayrollList'
import { useFetch } from '../../../services/useFetch'
import {
    constructOptionsSelect,
    downloadFile,
    getAllQueryParams,
    setCurrency,
    setQueryParams,
} from '../../../utils/utils'
import { PayrollNotesContainer } from '../payroll-notes/PayrollNotesContainer'

const INIT_COLUMN_EARNING = {
    name: 'Earning',
    key: 'earning',
    classNameHeader: '!text-center',
}

const INIT_COLUMN_DEDUCTION = {
    name: 'Deduction',
    key: 'deduction',
    classNameHeader: '!text-center',
}

const INIT_SUB_COLUMN = {
    name: null,
    key: null,
    isShowTooltip: true,
    classNameHeader: '!text-center max-w-0 !min-w-[150px]',
    classNameTooltip: 'font-medium truncate',
    className: '!text-center',
    render: ({ value }) => <div>{setCurrency(value)}</div>,
}

export const PayrollDetailContainer = () => {
    const location = useLocation()

    if (location.pathname.includes('payroll-notes')) {
        return <PayrollNotesContainer />
    }

    return <PayrollDetailContent />
}

const PayrollDetailContent = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const payrollId = searchParams.get('payrollId')
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_QUERY_DETAIL
    const [showModal, setShowModal] = useState({
        export: false,
        download: false,
    })
    const [optionsFilter, setOptionsFilter] = useState([])
    const [isShowToast, setIsShowToast] = useState(false)
    const [toastMessage, setToastMessage] = useState('')
    const [selectedItems, setSelectedItems] = useState([])
    const {
        data: payrollDetail,
        fetching: getPayrollDetail,
        isLoading,
    } = useFetch({ ...API_PAYROLL_LIST.PAYROLL_DETAIL, initPathVariable: payrollId }, INITIAL_DATA_QUERY_DETAIL)
    const { fetching: exportPayrollDetail } = useFetch({
        ...API_PAYROLL_LIST.EXPORT_PAYROLL_DETAIL,
        initPathVariable: payrollId,
    })
    const { fetching: departmentList } = useFetch(API_PAYROLL_LIST.DEPARTMENT_LIST)
    const { fetching: bulkDownloadPayroll } = useFetch(API_PAYROLL_LIST.BULK_DOWNLOAD_PAYROLL)

    useEffect(() => {
        const { payrollId, ...queryParams } = query
        getPayrollDetail({ ...queryParams })
    }, [location?.search])

    useEffect(() => {
        departmentList().then((response) => {
            const list = constructOptionsSelect(
                [
                    {
                        name: 'Semua Department',
                        id: null,
                    },
                    ...response?.data,
                ],
                'name',
                'id',
            )
            setOptionsFilter(list)
        })
    }, [])

    const setModal = (item) => {
        setShowModal((prev) => ({ ...prev, ...item }))
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const clearToast = () => {
        setIsShowToast(false)
        setToastMessage('')
    }

    const onExport = () => {
        const combineObj = { ...INITIAL_DATA_QUERY_DETAIL, ...query }
        const { page, limit, payrollId, ...payload } = combineObj
        exportPayrollDetail({...payload, employee_payroll_ids: selectedItems?.map((item) => item?.id)}, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `payroll-${payrollId}-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setToastMessage('Payroll Exported')
            setIsShowToast(true)
            setModal({ export: false })
        })
    }

    const onDownloadPayslip = async () => {
        const combineObj = { ...INITIAL_DATA_QUERY_DETAIL, ...query }
        const { page, limit, payrollId, ...restQuery } = combineObj
        const payload = { ...restQuery, employee_payroll_ids: selectedItems?.map((item) => item?.id) }
        await bulkDownloadPayroll(payload, payrollId)
        setToastMessage(
            'Generate dokumen Payslip sedang berlangsung. Dokumen akan di kirimkan ke email anda apabila proses sudah selesai dilakukan.',
        )
        setIsShowToast(true)
        setModal({ download: false })
    }

    const getColumnTable = () => {
        const column = [...TABLE_PAYROLL_DETAIL.column]
        const subColumn = { earning: [], deduction: [] }
        payrollDetail?.data?.result?.column_map_earning?.map((item) =>
            subColumn?.earning.push({ ...INIT_SUB_COLUMN, ...item }),
        )
        payrollDetail?.data?.result?.column_map_deduction?.map((item) =>
            subColumn?.deduction.push({ ...INIT_SUB_COLUMN, ...item }),
        )

        if (subColumn?.deduction?.length) {
            const deductionObj = { ...INIT_COLUMN_DEDUCTION, subColumn: subColumn?.deduction }
            column.splice(10, 0, deductionObj)
        }

        if (subColumn?.earning?.length) {
            const earningObj = { ...INIT_COLUMN_EARNING, subColumn: subColumn?.earning }
            column.splice(10, 0, earningObj)
        }

        return column
    }

    const props = {
        dataList: payrollDetail?.data,
        columnTable: getColumnTable(),
        isLoading,
        query,
        optionsFilter,
        showModal,
        setModal,
        isShowToast,
        toastMessage,
        onExport,
        clearToast,
        onChangeQuery,
        onDownloadPayslip,
        selectedItems,
        setSelectedItems,
    }

    return <PayrollDetail {...props} />
}
